<template>
    <v-main class="pa-2" fluid>

        <v-row>
        <v-col
            cols="12"
            md="4"
            lg="4"
        >
        <v-btn @click="dialog = true" color="primary">Add Rig</v-btn>

            <v-data-table
                :headers="headers"
                :items="rigs"
                :expanded.sync="expandedRigs"
                item-key="name"
                show-expand
                :items-per-page="20"
                class="elevation-1">

                <template v-slot:item.upcoming_inspection="{ item }">  

                    <span v-if="item.upcoming_inspection">{{new Date(item.upcoming_inspection).toLocaleString("en-AU",  { timeZone : "UTC", year: 'numeric', month: 'short', day: 'numeric' })}}</span>
                </template>

                    <template v-slot:expanded-item="{ headers, item }">
                      <td :colspan="headers.length" class="expanded-actions">
                    
                    <v-switch :disabled="(item.components.length < componentTypes.length) && item.status == 0 " :success="item.status == 1 ? true : false" @change="updateRigStatus(item)"
                              v-model="item.status"
                              inset
                              :label="getSwitchLabel(item.status)"
                            ></v-switch>   
                    <v-btn icon small class="blue--text" @click="reset(item)">
                      <v-icon center>mdi-update</v-icon>
                      </v-btn>

                    <v-btn icon small @click="edit(item)">
                      <v-icon center>mdi-pencil</v-icon> 
                    </v-btn>

                    <v-btn :disabled="item.status == 1" icon small color="red" @click="deleteRig(item.id)">
                      <v-icon center>mdi-delete-forever</v-icon> 
                    </v-btn>
                    

                      </td>
                    </template>
                </v-data-table>
                </v-col>
            <v-col
        cols="12"
        md="8"
        lg="8"
      >

      <ComponentForm @showSnack="showSnack" />
            </v-col>
                <v-dialog v-model="dialog" @keydown.esc="dialog = false" persistent max-width="98%">
                    <v-card color="lighten-1">
                        <v-toolbar>
                                <v-toolbar-title>
                                    <span class="headline">{{formTitle}}</span>
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                        <v-card-text>


                        <v-form ref="form" v-model="valid" class="row">
                            <v-col cols="3" md="3">
                                <v-text-field :rules="req" label="Number/Reference" v-model="editedItem.name" required></v-text-field>

                                <!-- <div v-else>
                                    <label>Number/Reference</label>
                                    <v-text-field :rules="req" v-model="editedItem.name" required></v-text-field>
                                </div> -->
                            </v-col>

                            <v-col cols="3" md="3" v-for="type in componentTypes" :key="type.id">

                                <div v-if="editedIndex === -1">

                                    <v-select  v-model="selComponents[type.fieldName]" 
                                        :disabled="getAvailableByType(type.id).length == 0"
                                        :items="getAvailableByType(type.id)"
                                                    item-text="name"
                                                    item-value="id"
                                                    :label="type.name"
                                                    :value="selComponents[type.fieldName]"
                                                    >
                                    </v-select>
                                </div>

                                <div v-else>
                                    <!-- <label >{{type.name}}</label> -->
                                        <v-select v-model="selComponents[type.fieldName]"
                                        :disabled="getChangeComponentOptions(type.id).length == 0"
                                        :items="getChangeComponentOptions(type.id)"
                                                    item-text="name"
                                                    item-value="id"
                                                    :label="type.name"
                                                    >
                                        </v-select>
                                </div>
                                    </v-col>
                            </v-form>
                            
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                            <v-btn color="blue darken-1" type="submit" @click="save" :disabled="!valid">Save</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                
        </v-row>


<v-snackbar
                v-model="snackbar"
              >
                {{ snackbartext }} 

                <template v-slot:action="{ attrs }">
                  <v-btn
                    color="orange"
                    text
                    v-bind="attrs"
                    @click="snackbar = false"
                  >
                    Close
                  </v-btn>
                </template>
              </v-snackbar>
    </v-main>
</template>

<script>
    import { mapState } from 'vuex'
    import ComponentForm from '../components/ComponentForm.vue'


    

    export default {
        components: { ComponentForm },
        data() {
            return {
                headers: [
                    
                    { text: 'Rig', align: 'start', sortable: true, value: 'rig', },
                    { text: 'Upcoming Inspection', align: 'start', sortable: true, value: 'upcoming_inspection', }, 
                    { text: 'Jumps Left', align: 'start', sortable: true, value: 'jumps_left', }, 
                    // { text: '', align: 'start', sortable: true, value: 'status', },
                    // { text: '', align: 'start', sortable: true, value: 'actions', },
                ],

                snackbar : false,
                snackbartext : "This Rig has Offline Components",

                dialog: false,
                editedIndex: -1,
                valid: true,
                lazy: true,
                isEditing: null,

                editedItem : {
                    name : "",
                    components : [],
                    client_id : this.$store.state.uuid
                },

                selComponents : {

                    mainParachute_id : null,
                    reserveParachute_id : null,
                    aad_id : null,
                    mainLineset_id : null,
                    Dbag_id : null,
                    Drogue_id : null,
                    killLane_id : null,
                    drogueBridleUpper_id : null,
                    drogueBridleLower_id : null,
                    closingLoop_id : null,
                    risers_id : null,
                    toggles_id : null,
                    reserveHandle_id : null,
                    cutawayHandle_id : null,
                    freebag_id : null,
                    reservePilotChute_id : null,
                    slider_id : null,
                    disk_id : null,
                    diskCover_id : null,
                    recoilRipcord_id : null,
                    skyhook_id : null,
                    sliderBumpers_id : null,
                    rigContainer_id : null
                },

                //req: [ v => !!(v && v.length) || 'Item is required'],
                req: [(v) => !!v || "Item is required"],
            }
        },

        mounted () {
            this.$store.dispatch('fetchRigs')
            // this.$store.dispatch('fetchComponents')
            this.$store.dispatch('fetchComponentTypes')
        },

        computed: {
            ...mapState(['rigs','components','componentTypes']),



            expandedRigs : {
                get () {
                    return this.rigs
                },

                set(expanded) {
                    return expanded
                }
            },

            available() {

            return this.components.filter(function(c) {
                return c.rig_id == 0
              }) 


            },

            componentsByRig() {


                const rig_id = this.editedItem.id
                
                return this.components.filter(function(c) {

                    const ID = c.rig.length > 0 ? c.rig[0].id : 0
                    return ID == rig_id
                })

            },

            allSelectBoxes() {

                return this.editedIndex === -1 ? this.componentTypes : this.componentsByRig
            },



            formTitle () {
                return this.editedIndex === -1 ? 'New Rig' : 'Edit Rig'
            },


            


        },

        watch: {
            dialog (val) {
                val || this.close()
            },


        },
        
        methods: {

            showSnack(){
                this.snackbar = true
            },


            updateRigStatus(item) {


                const offline = this.components.filter(function(c) {

                    const ID = c.rig_id != 0 ? c.rig_id : 0

                    return ID == item.id && c.status == 0
                })
 

                if ( offline.length > 0 && item.status ) {

                    this.snackbar = true
                    item.status = false


                    } else {

                        this.editedIndex = this.rigs.indexOf(item)
                        this.editedItem = Object.assign({}, item)
                
                
                    axios.put('/api/rigs/updateStatus/' + this.editedItem.id, this.editedItem)
                        .then( response => {
                                            
                                this.close()
                                            
                        })
                        .catch( err => {
                            console.log( err )
                    })


                }

            },

            getSwitchLabel(val) {

                return val ? 'Online' : 'Offline'
            },


            getAvailableByType(id) {

            return this.available.filter(function(c) {
                return c.component_type_id == id && c.status == 1
              }) 

                //return ['Main Parachute', 'Reserve Parachute', 'AAD', 'Main Lineset', 'D Bag', 'Drogue', 'Kill line', 'Drogue Bridle upper', 'Drogue Bridle lower', 'Closing loop', 'Risers', 'Toggles', 'reserve handle', 'cutaway handle', 'Freebag', 'Reserve Pilot Chute', 'Slider', 'Disk', 'Disk Cover', 'Recoil ripcord', 'Skyhook']
            },

            getChangeComponentOptions(component_type_id) { //add the Component that is currently selected


               const item = this.editedItem.components.find(x => x.component_type_id === component_type_id) || null


                const allItems = this.getAvailableByType(component_type_id) 

                if (item)
                { 
                    const type = this.componentTypes.find(t => t.id == component_type_id)

                    this.selComponents[type.fieldName] = item.id
                    allItems.unshift(item) 
                }

                return allItems
            },


            edit(item) { 

                this.editedIndex = this.rigs.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialog = true

            },

            close () {
                this.dialog = false
                this.$nextTick(() => {
                  this.editedItem = Object.assign({}, this.defaultItem)
                  this.editedIndex = -1
                  
                })
              },


              save () {


                this.editedItem.client_id = this.$store.state.uuid
                this.editedItem.componentIDs  = Object.values(this.selComponents) 


                this.editedItem.componentIDs = this.editedItem.componentIDs.filter((c) => {
                    return c != null
                })


            this.editedItem.status = this.editedItem.components && this.editedItem.components.length < this.componentTypes.length ? 0 : 1


                if (this.editedIndex > -1) {


                    axios.put('/api/rigs/' + this.editedItem.id, this.editedItem)
                        .then( response => {

                            
                        this.$store.dispatch('fetchRigs')
                        this.$store.dispatch('fetchComponents')
                            
                        this.close()
                            
                    })
                        .catch( err => {
                            console.log( err )
                    })

                  
                } else {

                    this.editedItem.name = this.editedItem.name ? this.editedItem.name : " "
                    axios.post('/api/rigs', this.editedItem)
                    .then( response => {

                            this.$store.dispatch('fetchComponents')
                            this.$store.dispatch('fetchRigs')

                        this.close()
                        
                    })
                    .catch( err => {
                        console.log( err )
                    })
                  
                }

              },

            deleteRig(id) {
                confirm('Are you sure you want to delete this Rig? This action can not be undone') && 

                axios.delete('/api/rigs/' + id)
                        .then( response => {

                            const index = this.rigs.map(function (f) { return f.id }).indexOf(id)

                            this.$store.state.rigs.splice(index, 1)
                        })
                        .catch( err => {
                            console.log( err )
                        })
              },


              reset(item) {


                var checkNotes = prompt('Inspection Notes', '--') 

                  if ( checkNotes ) {
                        
                        this.editedIndex = this.rigs.indexOf(item)
                        this.editedItem = Object.assign({}, item)

                        this.editedItem.lastCheckNotes = checkNotes


                        axios.put('/api/rigs/reset/' + this.editedItem.id, this.editedItem)
                            .then( response => {
                            
                                this.$store.dispatch('fetchRigs') 
                                this.$store.dispatch('fetchComponents')

                                this.close()
                                                    
                        }).catch( err => {
                            console.log( err )
                        })



                  } else {
                    console.log("Canceled by user");
                  }

              }

          }
    }
</script>